export default {
    apiKey: "AIzaSyAqbe9OL75I9iP9YTUQsSWL9X6PmzDQBas",
    authDomain: "ayun-quantity-uat3.firebaseapp.com",
    projectId: "ayun-quantity-uat3",
    storageBucket: "ayun-quantity-uat3.appspot.com",
    messagingSenderId: "40963443745",
    appId: "1:40963443745:web:88a8d4b942a6ea75eba760",
    measurementId: "G-L56V3HN49F"
}